@for (vm of viewModel(); track trackByEntry($index, vm)) {
  <sd-cart-list-item
    [entry]="vm.entry"
    [quantityControl]="vm.control.get('quantity')"
    [isFirstItem]="$first"
    [isLastItem]="$last"
  ></sd-cart-list-item>
}
